export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
// dev key: a83a04be-2610-4bb1-864a-e9c13b429357
export const KEY = 'bd1cf07a-a0cb-44d7-8d16-0a85b599868a';
export const MODAL_CLOSE_SEC = 2.5;
export const SERVINGS_TO_UPLOAD = 4;
export const SPOONACULAR_ENDPOINT = `https://api.spoonacular.com/recipes/parseIngredients`;
export const SPOONACULAR_API_KEY = '7f2270bee21d4e20b6d1ac4a04ced5c2';
export const MS_PER_DAY = 1000 * 60 * 60 * 24;
export const FIRST_MONDAY = new Date(0).getTime() + 4 * MS_PER_DAY;
